import { cn } from '@/lib/cn';
import { formatMoney } from '@/lib/money';
import type { Money as MoneyValue } from '@/lib/money';

/** Presentation only: shows the amount the server sent, with tabular numerals so columns line up. */
export function Money({ value, className }: { value: MoneyValue; className?: string }) {
  return <span className={cn('tabular-nums', className)}>{formatMoney(value)}</span>;
}
